import type { ReactNode } from "react";

// The bar above a table once rows are selected (docs/design-system.md §0.4a,
// §0.8; plan M8 step 8d): how many rows and what they ask of the person, a
// line on what happens next, and the actions, primary last.

export function SelectionBar({ label, count, note, children }: { label: string; count: ReactNode; note?: ReactNode; children: ReactNode }) {
  return <div className="z-selection-bar" role="region" aria-label={label} aria-live="polite">
    <div className="z-selection-text">
      <strong>{count}</strong>
      {note && <span className="z-selection-note">{note}</span>}
    </div>
    <div className="z-selection-actions">{children}</div>
  </div>;
}
